import { Sites } from '@ps/platform-message-framework/common/Sites';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import CTAButton from '../../../../../CTAButton/CTAButton';

import {
  TXTINT_CurrSign_EUR,
  TXTINT_Format_Money_Sign,
  TXTWCL_Deposit,
  TXTWCL_EUR_N0,
  TXTWCL_Max_30
} from './Deposit.messages.json';
import { container, cta, description } from './Deposit.scss';

export const Deposit: React.FC = () => {
  const isFrance = useSelector(select.cms.getSiteId) === Sites.FRA;
  const isRomania = useSelector(select.cms.getSiteId) === Sites.ROM;
  const depositLimitTranslation = isRomania ? (
    <Translation
      {...TXTINT_Format_Money_Sign}
      values={{ 0: <Translation {...TXTINT_CurrSign_EUR} />, 1: 200 }}
    />
  ) : (
    <Translation {...TXTWCL_EUR_N0} values={{ 0: 800 }} />
  );

  return (
    <div className={container}>
      <div className={description}>
        <strong>
          <Translation {...TXTWCL_Deposit} />
        </strong>
        <h3>
          {!isFrance && (
            <>
              <Translation {...TXTWCL_Max_30} /> {depositLimitTranslation}
            </>
          )}
        </h3>
      </div>
      <div className={cta}>
        <CTAButton
          type="submit"
          translation={TXTWCL_Deposit}
          variant={isRomania ? 'primary' : 'secondary'}
        />
      </div>
    </div>
  );
};
